import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  CompanyInvestorVisibility,
  EntityMeta,
  FeatureStage,
  OrganizationDetails,
  OrganizationLicenseData,
  OrganizationLicenseUpdatePayload,
  UserRole,
} from '@qtek/shared/models';

import { OrganizationUserUpdatePayload } from './organizations.service';

export const OrganizationsActions = createActionGroup({
  source: 'Organizations Feature',
  events: {
    'Load Organizations': emptyProps(),
    'Clear Organizations': emptyProps(),
    'Load Organizations Success': props<{
      payload: OrganizationDetails[];
      meta?: EntityMeta;
    }>(),
    'Load Organizations Failure': props<{ error: unknown }>(),
    'Get Organization Details': props<{ id: string }>(),
    'Get Organization Details Success': props<{ res: OrganizationDetails }>(),
    'Get Organization Details Failure': props<{ error: unknown }>(),
    'Get Organization Licenses': emptyProps(),
    'Get Organization Licenses Success': props<{
      res: OrganizationLicenseData[];
    }>(),
    'Get Organization Licenses Failure': props<{ error: unknown }>(),
    'Update Organization Licenses': props<{
      payload: OrganizationLicenseUpdatePayload;
    }>(),
    'Update Organization Licenses Success': props<{ res: unknown }>(),
    'Update Organization Licenses Failure': props<{ error: unknown }>(),

    'Delete Organization Account': props<{ acnId: string }>(),
    'Delete Organization Account Success': props<{ acnId: string }>(),
    'Delete Organization Account Failure': props<{ error: unknown }>(),

    'Update Organization': props<{
      id: string;
      testOrganizationFlag: boolean;
    }>(),
    'Update Organization Success': props<{
      res: { testOrganizationFlag: boolean };
    }>(),
    'Update Organization Failure': props<{ error: unknown }>(),

    'Update Investor Visibility': props<{
      id: string;
      investorVisibility: CompanyInvestorVisibility;
    }>(),
    'Update Investor Visibility Success': props<{
      res: { investorVisibility: CompanyInvestorVisibility };
    }>(),
    'Update Investor Visibility Failure': props<{ error: unknown }>(),

    'Update Feature Stage': props<{
      id: string;
      featureStage: FeatureStage;
    }>(),
    'Update Feature Stage Success': props<{
      res: { featureStage: FeatureStage };
    }>(),
    'Update Feature Stage Failure': props<{ error: unknown }>(),

    'Update Organization User': props<{
      userId: string;
      payload: OrganizationUserUpdatePayload;
    }>(),
    'Update Organization User Success': props<{ userId: string }>(),
    'Update Organization User Failure': props<{
      error: unknown;
    }>(),

    'Reset User Password': props<{
      userId: string;
    }>(),
    'Reset User Password Success': props<{
      userId: string;
      message?: string;
    }>(),
    'Reset User Password Failure': props<{
      error: unknown;
    }>(),

    'Reset User Password Link': props<{
      userId: string;
    }>(),
    'Reset User Password Link Success': props<{
      userId: string;
      link: string;
    }>(),
    'Reset User Password Link Failure': props<{
      error: unknown;
    }>(),

    'Generate On Behalf Token': props<{
      userId: string;
    }>(),
    'Generate On Behalf Token Success': props<{
      userId: string;
      token: string;
    }>(),
    'Generate On Behalf Token Failure': props<{
      error: unknown;
    }>(),

    'Login As Another User': props<{
      token: string;
    }>(),
    'Login As Another User Success': props<{
      userData: LoginAsAnotherUserResponse;
    }>(),
    'Login As Another User Failure': props<{
      error: unknown;
    }>(),

    'Update Organization Name': props<{
      acnId: string;
      name: string;
    }>(),
    'Update Organization Name Success': props<{
      res: { companyName: string };
    }>(),
    'Update Organization Name Failure': props<{ error: unknown }>(),

    'Add Organization Domain': props<{
      acnId: string;
      domain: string;
    }>(),
    'Add Organization Domain Success': props<{
      res: unknown;
    }>(),
    'Add Organization Domain Failure': props<{
      error: unknown;
    }>(),

    'Remove Login Block': props<{ email: string }>(),
    'Remove Login Block Success': props<{ email: string; message?: string }>(),
    'Remove Login Block Failure': props<{ error: unknown }>(),
  },
});

export interface LoginAsAnotherUserResponse {
  wsToken?: string;
  user?: { email?: string; role?: UserRole };
  person?: { firstName?: string; lastName?: string };
  logoDocId?: string;
}
